import { IEpexGrid } from '@/interfaces/powerMarkets/epex/IEpexGrid.ts';
import { ITradeContract } from '@/interfaces/powerMarkets/epex/ITradeContract.ts';
import { ApiPromise, IApiCall, useApi } from '@/api/useApi.ts';

const apiCallMap: Record<string, IApiCall> = {
    Gb: useApi('epex'),
    France: useApi('epexFrance'),
};

function getGrid (countryId = 'Gb'): ApiPromise<IEpexGrid> {
    if (!apiCallMap[countryId]) throw new Error(`EPEX API for country ${countryId} is not configured.`);
    return apiCallMap[countryId].get<IEpexGrid>({
        endpoint: '/EpexGrid',
    });
}

function getContractDataById (contractId: number, countryId = 'Gb'): ApiPromise<ITradeContract> {
    if (!apiCallMap[countryId]) throw new Error(`EPEX API for country ${countryId} is not configured.`);
    return apiCallMap[countryId].get<ITradeContract>({
        endpoint: `/EpexContractSlideout/${contractId}`,
    });
}

export const epexApi = {
    getContractDataById,
    getGrid,
};
